export default "__VITE_ASSET__DGMcMN$r__"